import Reflux from 'reflux';
export default Reflux.createActions([ 
  'update'
]);



// WEBPACK FOOTER //
// ./medscape_modules/email-modal/error-messages/actions.js